import {Component, Input} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap';
import {Team} from '../../models/team';

@Component({
    selector: 'app-team-modal',
    template: `
        <div class="modal-header">
            <h4 class="modal-title pull-left">{{title}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <br>
            <div class="container-form">
                <div class="input-group">
                    <label class="col-5">Team name</label>
                    <input class="form-control col-7" placeholder="Name"
                           [ngModel]="_team.name"
                           [disabled]="editMode"/>
                </div>
                <div class="input-group">
                    <label class="col-5">Logo</label>
                    <div class="col-7">
                        <input class="form-control small fullWith" type="file"
                               (change)="readUrl($event)"
                               [disabled]="editMode"/>
                        <img [src]="_team.logoPath" width="90" height="90">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="bsModalRef.hide()" translate="cancel"></button>
            <ng-container *ngIf="editMode">
                <button type="button" class="btn btn-success" (click)="clickOk()" translate="save">Update</button>
            </ng-container>
            <ng-container *ngIf="!editMode">
                <button type="button" class="btn btn-success" (click)="clickOk()" translate="save">Register!</button>
            </ng-container>
        </div>`,
    providers: [BsModalService]
})

export class TeamModalComponent {

    @Input() editMode: boolean;
    @Input() newRegister: boolean;
    @Input() title: string = '';
    @Input() message: string = '';

    public url;

    public _team: Team;

    constructor(public bsModalRef: BsModalRef) {
        this.title = 'New Team';
        this.editMode = false;
        this.editMode = false;
        this._team = new Team();
    }

    set team(value: Team) {
        console.log('set team: ', value);
        this._team = value;
    }

    public clickOk() {
        // console.log('Click ok...');
        if (this._team.name && this._team.logoPath) {

        }
    }

    readUrl(event: any) {
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (event: any) => {
                this._team.logoPath = event.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modals/team-modal.ts